export default __webpack_public_path__ + "static/media/trash-can.a235ef79.svg";